/**
 * Pages of the previous docs site (Mintlify, v1) and where they live now, so
 * links in old emails, posts and search results keep working. The two FAQ
 * pages kept their paths: the checkers' User-Agent links to one of them.
 */
export const legacyRedirects: { from: string; to: string }[] = [
  { from: "/get-started/sign-up", to: "/quickstart" },
  { from: "/get-started/create-a-team", to: "/account/teams-and-roles" },
  { from: "/get-started/your-first-monitor", to: "/quickstart" },

  { from: "/features/projects", to: "/account/projects" },
  { from: "/features/teams/team-members", to: "/account/members" },

  { from: "/features/website-monitoring/overview", to: "/monitors/introduction" },
  { from: "/features/website-monitoring/protocols", to: "/monitors/introduction" },
  { from: "/features/website-monitoring/dashboard", to: "/monitors/introduction" },
  { from: "/features/website-monitoring/locations", to: "/monitors/locations-and-checks" },
  { from: "/features/website-monitoring/pause-and-delete", to: "/monitors/pause-and-delete" },
  { from: "/features/website-monitoring/checks/uptime-monitoring", to: "/monitors/http" },
  { from: "/features/website-monitoring/checks/performance-monitoring", to: "/monitors/performance" },
  { from: "/features/website-monitoring/checks/ssl-monitoring", to: "/monitors/certificates" },

  { from: "/features/server-monitoring/overview", to: "/hosts/introduction" },
  { from: "/features/server-monitoring/agent", to: "/hosts/install-the-agent" },
  { from: "/features/server-monitoring/dashboards/overview", to: "/hosts/metrics" },
  { from: "/features/server-monitoring/dashboards/performance", to: "/hosts/metrics" },
  { from: "/features/server-monitoring/dashboards/disk-usage", to: "/hosts/metrics" },
  { from: "/features/server-monitoring/dashboards/network", to: "/hosts/metrics" },

  { from: "/features/domains/overview", to: "/domains/introduction" },
  { from: "/features/domains/dashboard", to: "/domains/introduction" },
  { from: "/features/domains/checks", to: "/domains/checks" },
  { from: "/features/domains/pause-and-delete", to: "/domains/introduction" },

  { from: "/features/alerting/overview", to: "/alerting/alerts" },
  { from: "/features/alerting/alert-policies", to: "/alerting/escalation-paths" },
  { from: "/features/alerting/integrations/email", to: "/alerting/channels" },
  { from: "/features/alerting/integrations/discord", to: "/alerting/channels" },
  { from: "/features/alerting/integrations/microsoft-teams", to: "/alerting/channels" },
  { from: "/features/alerting/integrations/pushover", to: "/alerting/channels" },
  { from: "/features/alerting/integrations/slack", to: "/alerting/slack" },
  { from: "/features/alerting/integrations/sms", to: "/alerting/telegram-and-phone" },
  { from: "/features/alerting/integrations/voice", to: "/alerting/telegram-and-phone" },
  { from: "/features/alerting/integrations/telegram", to: "/alerting/telegram-and-phone" },
  { from: "/features/alerting/integrations/webhook", to: "/alerting/webhooks" },

  { from: "/features/incident-management/overview", to: "/incidents/introduction" },
  { from: "/features/incident-management/details", to: "/incidents/introduction" },
  { from: "/features/incident-management/settings", to: "/incidents/introduction" },
  { from: "/features/incident-management/severity-levels", to: "/incidents/introduction" },
  { from: "/features/incident-management/timeline", to: "/incidents/updates-and-roles" },
  { from: "/features/incident-management/screenshots", to: "/monitors/http" },
  { from: "/features/incident-management/smart-incident-merging", to: "/alerting/alerts" },
  { from: "/features/incident-management/incident-ai", to: "/incidents/introduction" },

  { from: "/features/status-pages/automation", to: "/status-pages/incidents" },
  { from: "/features/status-pages/branding", to: "/status-pages/appearance" },
  { from: "/features/status-pages/components", to: "/status-pages/components" },
  { from: "/features/status-pages/custom-domains", to: "/status-pages/custom-domains" },
  { from: "/features/status-pages/incidents", to: "/status-pages/incidents" },
  { from: "/features/status-pages/security", to: "/status-pages/access" },
  { from: "/features/status-pages/settings", to: "/status-pages/introduction" },
  { from: "/features/status-pages/subscriptions", to: "/status-pages/subscribers" },
  { from: "/features/status-pages/user-reports", to: "/status-pages/issue-reports" },
];
